import { render, staticRenderFns } from "./PerformancePreviewFile.vue?vue&type=template&id=530be34d&"
import script from "./PerformancePreviewFile.vue?vue&type=script&lang=js&"
export * from "./PerformancePreviewFile.vue?vue&type=script&lang=js&"
import style0 from "./PerformancePreviewFile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports